import { styled } from '@mui/material';
import { BasicBox } from '../styles';

export const DeliveryCON = styled(BasicBox)`
  width: 100%;
  max-width: 100%;
  padding: 0;

  .header {
    padding: 0 16px;
    margin-bottom: 24px;
  }

  .address-map {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    grid-gap: 24px;
    padding: 0 16px;
  }

  .button {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .button button {
    max-width: 100%;
    width: 472px;
    margin: 40px auto;
    font-weight: 700;
  }

  @media (max-width: 768px) {
    .address-map {
      grid-template-columns: 1fr;
      grid-gap: 16px;
    }

    .button button {
      width: 100%;
      margin: 32px auto;
    }
  }

  @media (max-width: 480px) {
    padding: 0 8px;

    .header {
      padding: 0 8px;
    }

    .address-map {
      padding: 0 8px;
    }
  }
`;
